export default __webpack_public_path__ + "static/media/jungle-rain.07a47901.mp3";